export default __webpack_public_path__ + "static/media/logo-login.32a255b3.jpg";